import * as THREE from 'three'

// The platform adds `data-id`, `data-mp` and `data-mpi` to every JSX element
// for visual editing, including React Three Fiber's. Fiber reads a dashed prop
// as a path into the object (`data-id` sets `object.data.id`), which throws when
// `object.data` is missing, so give three objects a `data` bag to write into.
const bag: Record<string, unknown> = {}

for (const proto of [
  THREE.EventDispatcher.prototype,
  THREE.Fog.prototype,
  THREE.FogExp2.prototype,
]) {
  if (!Object.prototype.hasOwnProperty.call(proto, 'data')) {
    Object.defineProperty(proto, 'data', { value: bag, writable: true, configurable: true })
  }
}
